import { Component, OnInit, ViewEncapsulation, WritableSignal } from "@angular/core";
import { MedOptionType } from "@mk/med-ui";
import { MedNotificationService } from "@mk/med-notification";
import { Router } from "@angular/router";
import { HttpClient, HttpParams } from "@angular/common/http";
import { env } from "@environments/environment";
import { catchError } from "rxjs";
import { BasketService } from "@app/components/basket/basket.service";
import { PAGINATION_OPTIONS } from "@app/components/supplies/supplies.component";
import { MoneyUtil } from "@app/utils/money.util";

@Component({
  selector: "app-basket",
  templateUrl: "./basket.component.html",
  styleUrls: ["/basket.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class BasketComponent implements OnInit  {

  constructor(public basketService: BasketService,
                private notificationService: MedNotificationService,
                private router: Router,
                private http: HttpClient) {
  }

  rows = 0;
  totalRows = 0;
  pageSize = 10;
  selectedPageNumber = 1;
  filterActive = true;
  filterField: string | string[] | null | undefined = "";
  tableBody:  { [key: string]: any; }[] = [];
  tabHeader: { label: string; key: string; date: boolean; filter: boolean; joinTable: string; }[] = tabHeaderBasket;
  options: MedOptionType<any>[] = [
    {
      label: "Мануальний",
      value: 1,
    },
    {
      label: "Автоматичний",
      value: 2,
    },
  ];
  visible: boolean | WritableSignal<boolean> = false;
  value = 2;
  loading = false;
  protected readonly paginationOptions = PAGINATION_OPTIONS;

  ngOnInit(): void {
    this.loadColumnOrder();
  }

  saveColumnOrder() {
    localStorage.setItem("basketColumnOrder", JSON.stringify(this.tabHeader));
  }

  loadColumnOrder() {
    const savedOrder = localStorage.getItem("basketColumnOrder");
    if (savedOrder) {
      this.tabHeader = JSON.parse(savedOrder);
    }
  }

  getSpecifications(
    order = "asc",
    field = "specificationId",
  ): void {
    let params = new HttpParams();
    const sortFieldAndOrder = `${field},${order}`;

    const specIds: string = this.basketService.getAllBasketItems();

    params = params.append("conditions[0].fieldName", "specificationId");
    params = params.append("conditions[0].values", specIds);
    params = params.append("conditions[0].operator", "IN");

    params = params.append("page", 0);
    params = params.append("size", 10000);
    params = params.append("sort", sortFieldAndOrder);

    this.http.get<{ [key: string]: any; }>(env.logisticsServiceBackend + "/logistics/v1/reserve/specifications", { params }).subscribe(data => {
      this.tableBody = data["content"];
      this.totalRows = data["totalElements"];
    });
  }

  loadData(): void {
    if (this.basketService.basketItems.size > 0) {
      this.getSpecifications();
    }
  }

  pageChange(pageNumber: number) {
    this.selectedPageNumber = pageNumber;
    // this.loadData(this.tableState)
  }

  pageSizeChanged(pageSize: number) {
    this.pageSize = pageSize;
    this.selectedPageNumber = 1;
    // this.loadData(this.tableState)
  }

  getFirstShowedRowIndex(): number {
    return this.selectedPageNumber === 1 ? 0 : (this.selectedPageNumber - 1) * this.pageSize;
  }

  getPathToStatusImg(rowElement: string): string {
    let color: string;
    switch (rowElement) {
    case "Ні": color = "red"; break;
    case "Запаси": color = "yellow"; break;
    default: color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  showModal() {
    this.visible = true;
  }

  clearBasket() {
    this.basketService.clearBasket();
    this.tableBody = [];
  }

  deleteItem(specId: string) {
    this.basketService.removeFromBasketById(specId);
    this.tableBody = this.tableBody.filter((item: any) => item["specificationId"] !== specId);
  }

  goToDistribution(): void {
    this.loading = true;
    const body: any = { automaticDistribution: this.value === 2, specificationIds: [] };

    this.tableBody.forEach(row => {
      body.specificationIds.push(row["specificationId"]);
    });

    this.http.post<any>(env.logisticsServiceBackend + "/logistics/v1/distributions/create", body)
      .pipe(
        catchError(response => {
          this.loading = false;
          this.notificationService.error(response.error.detail);
          throw response;
        }),
      )
      .subscribe(data => {
        this.clearBasket();
        this.loading = false;
        this.router.navigate(["/distribution/view/" + data["id"]]);
        this.notificationService.success("Розподіл створено");
      });
  }

  getStatusImgPath(rowElement: boolean): string {
    let color = "red";
    if (!rowElement) {
      color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  getWarehouseName(): string {
    if (this.tableBody.length > 0) {
      return this.tableBody[0]["warehouseName"];
    }
    return "";
  }

  getDirectionName(): string {
    if (this.tableBody.length > 0) {
      return this.tableBody[0]["good"]["direction"]["shortName"];
    }
    return "";
  }

  getTotalQuantity(): number {
    let quantity = 0;
    this.tableBody.forEach((item: any) => {
      quantity += item["extra"]["availableForDistribution"];
    });
    return quantity;
  }

  getRowSum(availableForDistribution: number, adjUnitPrice:number): string {
    return  MoneyUtil.toFixedTrunc(adjUnitPrice * availableForDistribution, 2);
  }

  getTotalSum(): number {
    let sum = 0;
    this.tableBody.forEach((item: any) => {
      sum += item["extra"]["availableForDistribution"] * item["adjUnitPrice"];
    });
    return MoneyUtil.toFixedTrunc(sum, 2);
  }

  distrTypeChanged($event: number) {
    this.value = $event;
  }
}

export const tabHeaderBasket = [
  { key: "mnnId", label: "MHH ID", date: false, filter: true, enum: true, joinTable: "" },
  { key: "mnnName", label: "MHH", date: false, filter: true, enum: false, joinTable: "goods" },
  { key: "dosage", label: "Дозування", date: false, filter: true, enum: false, joinTable: "goods" },
  { key: "tradeName", label: "Торгова назва", date: true, filter: true, enum: false, joinTable: "" },
  { key: "5", label: "Серія/Каталожний номер", date: true, filter: true, enum: false, joinTable: "" },
  { key: "quantity", label: "Кількість", date: false, filter: true, enum: false, joinTable: "" },
  { key: "unitPrice", label: "Ціна за одиницю, грн", date: false, filter: true, enum: false, joinTable: "" },
  { key: "totalPrice", label: "Загальна сума, грн", date: false, filter: true, enum: false, joinTable: "" },
  { key: "9", label: "Статус", date: false, filter: true, enum: false, joinTable: "" },
  { key: "10", label: "Відмова", date: false, filter: true, enum: false, joinTable: "" },
];
